
import { View} from 'backbone';
import _template from 'properties/main/inputpurpose-autofill.ejs';
import undoService          from 'UndoService'

class MainInputPurposeAutofillView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change select' : 'updateAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        if(!this.model.get("autocomplete") || this.model.get("autocomplete") === ""){
            this.model.set("autocomplete", "on", {silent:true});
        }

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldVal = this.model.get(propName);
        const colId = this.colId;

        if(this.model.get("factoryKey") !== "control_table"){        
            this.model.set( propName, propVal, {silent:true} );
        }
        else{
            this.model.get('gridData')[colId].attributes[propName] = propVal;
        }
        this.render();

        undoService.add({
            undo:() => {
                if(this.model.get("factoryKey") !== "control_table"){        
                    this.model.set( propName, oldVal, {silent:true} );
                }
                else{
                    this.model.get('gridData')[colId].attributes[propName] = oldVal;
                }
                this.render();
            },
            redo:() => {
                if(this.model.get("factoryKey") !== "control_table"){        
                    this.model.set( propName, propVal, {silent:true} );
                }
                else{
                    this.model.get('gridData')[colId].attributes[propName] = propVal;
                }
                this.render();
            }
        },'Autocomplete')
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const value =  this.model.get("factoryKey") !== "control_table" ? this.model.get("autocomplete") : this.model.get('gridData')[this.colId].attributes["autocomplete"];
        $("#autocomplete").val(value);

        this.delegateEvents();
        return this;
    }

}

export default MainInputPurposeAutofillView;